// extracted by mini-css-extract-plugin
export var botAvatar = "ChatbotDemo-module--botAvatar--b1bf9";
export var botBubbleContent = "ChatbotDemo-module--botBubbleContent--33253";
export var botMessage = "ChatbotDemo-module--botMessage--39a73";
export var bounce = "ChatbotDemo-module--bounce--1d34b";
export var bubbleColumn = "ChatbotDemo-module--bubbleColumn--77144";
export var bubbleContent = "ChatbotDemo-module--bubbleContent--712b3";
export var chartImage = "ChatbotDemo-module--chartImage--f46db";
export var chartImageWrap = "ChatbotDemo-module--chartImageWrap--0ed2b";
export var ctaButton = "ChatbotDemo-module--ctaButton--00a06";
export var fadeIn = "ChatbotDemo-module--fadeIn--32e29";
export var flipBack = "ChatbotDemo-module--flipBack--09ff2";
export var flipBackAvatar = "ChatbotDemo-module--flipBackAvatar--d1bc7";
export var flipBackInner = "ChatbotDemo-module--flipBackInner--a3560";
export var flipBackSubtitle = "ChatbotDemo-module--flipBackSubtitle--d0a35";
export var flipBackTitle = "ChatbotDemo-module--flipBackTitle--afa74";
export var flipCard = "ChatbotDemo-module--flipCard--2a211";
export var flipRevealed = "ChatbotDemo-module--flipRevealed--db8d4";
export var flipScene = "ChatbotDemo-module--flipScene--5179d";
export var flipSceneVisible = "ChatbotDemo-module--flipSceneVisible--cfabe";
export var header = "ChatbotDemo-module--header--e61aa";
export var headerActions = "ChatbotDemo-module--headerActions--6487b";
export var headerAvatar = "ChatbotDemo-module--headerAvatar--25912";
export var headerInfo = "ChatbotDemo-module--headerInfo--602c0";
export var headerSubtitle = "ChatbotDemo-module--headerSubtitle--47865";
export var headerTitle = "ChatbotDemo-module--headerTitle--acd47";
export var inputArea = "ChatbotDemo-module--inputArea--c95ad";
export var inputCta = "ChatbotDemo-module--inputCta--3f83c";
export var inputCtaArrow = "ChatbotDemo-module--inputCtaArrow--dee42";
export var inputCtaHint = "ChatbotDemo-module--inputCtaHint--3e379";
export var inputCtaHintLink = "ChatbotDemo-module--inputCtaHintLink--40c6a";
export var inputCtaText = "ChatbotDemo-module--inputCtaText--4eb92";
export var inputCtaTyping = "ChatbotDemo-module--inputCtaTyping--69304";
export var inputPulse = "ChatbotDemo-module--inputPulse--bb344";
export var messageAvatar = "ChatbotDemo-module--messageAvatar--ef6ba";
export var messageBubble = "ChatbotDemo-module--messageBubble--502c7";
export var messageList = "ChatbotDemo-module--messageList--18f4e";
export var messageListInner = "ChatbotDemo-module--messageListInner--69ae3";
export var onlineDot = "ChatbotDemo-module--onlineDot--21216";
export var quickActionChip = "ChatbotDemo-module--quickActionChip--0696c";
export var quickActions = "ChatbotDemo-module--quickActions--e4e0c";
export var reasoning = "ChatbotDemo-module--reasoning--98635";
export var reasoningChevron = "ChatbotDemo-module--reasoningChevron--52667";
export var reasoningHeader = "ChatbotDemo-module--reasoningHeader--37514";
export var reasoningIcon = "ChatbotDemo-module--reasoningIcon--da5ba";
export var reasoningLabel = "ChatbotDemo-module--reasoningLabel--6afb0";
export var reasoningSpinner = "ChatbotDemo-module--reasoningSpinner--222ca";
export var reasoningSpinnerDot = "ChatbotDemo-module--reasoningSpinnerDot--3a53c";
export var reasoningStep = "ChatbotDemo-module--reasoningStep--92dee";
export var reasoningSteps = "ChatbotDemo-module--reasoningSteps--8a7ea";
export var typingDot = "ChatbotDemo-module--typingDot--76ee1";
export var typingDots = "ChatbotDemo-module--typingDots--68a54";
export var typingIndicator = "ChatbotDemo-module--typingIndicator--6e89a";
export var userAvatar = "ChatbotDemo-module--userAvatar--f157b";
export var userBubbleContent = "ChatbotDemo-module--userBubbleContent--6c27a";
export var userMessage = "ChatbotDemo-module--userMessage--a0b48";
export var widget = "ChatbotDemo-module--widget--42a1d";